import { render } from "./Notifiche40Giorni.vue?vue&type=template&id=48e70eb6"
import script from "./Notifiche40Giorni.vue?vue&type=script&lang=js"
export * from "./Notifiche40Giorni.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__